module.exports = __webpack_public_path__ + "_/_/_/node_modules/trumbowyg/dist/ui/icons.svg";